export const RANGE_LABEL = 'Adicionar Faixa de Juros por ';
export const RANGE_QUERY_LABEL = 'Faixa(s) de Juros por ';
export const ADD_RANGE_HINT = 'Adicionar Faixa';

export const FROM = 'De';
export const UNTIL = 'Até';
export const TRASH = 'Excluir Faixa';
